import { i18next } from '@frontend/i18n';

export const appointmentTypeString = (count: number) =>
  count === 1
    ? i18next.t('1 Appointment Type', { ns: 'scheduleServiceTypes' })
    : i18next.t('{{count}} Appointment Types', { count, ns: 'scheduleServiceTypes' });
